import { Box, BoxProps } from "@material-ui/core";
import React from "react";
import { BoxCard, Title } from "ui/componentes";

interface PageLayoutProps {
    title?: string;
    showInBoxCard?: boolean;
    boxCardProps?: BoxProps;
    height?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({
    title = "",
    children,
    showInBoxCard = true,
    boxCardProps,
    height,
}) => (
    <Box
        id="page_layout"
        display="flex"
        flexDirection="column"
        height={height}
        style={{ overflowX: "hidden", overflowY: "hidden", marginBottom: 80 }}
    >
        <Box
            id="page_layout_title"
            marginBottom={2}
            marginLeft={2}
            marginRight={2}
        >
            <Title text={title} />
        </Box>
        {showInBoxCard ? (
            <BoxCard
                id="page_layout_box_card"
                marginLeft={2}
                marginRight={2}
                {...boxCardProps}
            >
                {children}
            </BoxCard>
        ) : (
            <Box
                id="page_layout_box"
                marginLeft={2}
                marginRight={2}
                {...boxCardProps}
            >
                {children}
            </Box>
        )}
    </Box>
);

export { PageLayout };
